import { Controller } from '@hotwired/stimulus';
import { addMonths, endOfMonth, format } from 'date-fns';

export default class EnrollmentExtensionSelectionController extends Controller {
  static targets = [
    'select',
    'afterEffectedOn',
    'submit'
  ];

  static values = {
    beforeEffectedOn: String
  };

  connect() {
    if (this.hasAfterEffectedOnTarget) {
      this.#changeAfterEffectedOn(this.selectTarget.value);
    }

    this.#changeSubmitDisabled(this.selectTarget.value);
  }

  select(e) {
    if (this.hasAfterEffectedOnTarget) {
      this.#changeAfterEffectedOn(e.target.value);
    }

    this.#changeSubmitDisabled(e.target.value);
  }

  #changeAfterEffectedOn(selectedValue) {
    switch (selectedValue) {
      case 'half_year': {
        const date = new Date(this.beforeEffectedOnValue);
        this.afterEffectedOnTarget.innerHTML = format(endOfMonth(addMonths(date, 6)), 'yyyy/MM/dd');
        break
      }
      case 'one_year': {
        const date = new Date(this.beforeEffectedOnValue);
        this.afterEffectedOnTarget.innerHTML = format(endOfMonth(addMonths(date, 12)), 'yyyy/MM/dd');
        break
      }
      default: {
        this.afterEffectedOnTarget.innerHTML = '-';
      }
    }
  }

  #changeSubmitDisabled(selectedValue) {
    switch (selectedValue) {
      case 'half_year':
      case 'one_year': {
        this.submitTarget.disabled = false;
        break
      }
      default: {
        this.submitTarget.disabled = true;
      }
    }
  }
}
